import React from 'react';
import classNames from 'classnames';
import './index.scss';

interface IContentHeaderProps {
  title: string | React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  left?: React.ReactNode;
  right?: React.ReactNode;
}
const ContentHeader: React.FC<IContentHeaderProps> = ({ title, left, right, style, className }) => {
  return (
    <div style={style} className={classNames('common-content-header', className)}>
      <div className='common-content-header-left'>{left ? left : null}</div>
      <div className='common-content-header-title'>{title}</div>
      <div className='common-content-header-right'>{right ? right : null}</div>
    </div>
  );
};

export default ContentHeader;
